import { DarkModeProvider, DebugMenu } from '@amzn/event-engine-js-utils';
import AuthProvider from 'contexts/AuthProvider';
import { createBrowserHistory } from 'history';
import React, { FC, useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Router } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import AppSettings from 'services/app-settings';

const history = createBrowserHistory();

const Providers: FC = ({ children }) => {
    const [isSettingsHydrated, setIsSettingsHydrated] = useState(false);

    useEffect(() => {
        AppSettings().then(() => {
            setIsSettingsHydrated(true);
        });
    }, []);

    if (!isSettingsHydrated) {
        return null;
    }

    return (
        <RecoilRoot>
            <DarkModeProvider>
                <DebugMenu
                    gitInformation={{
                        sha: process.env.REACT_APP_GIT_SHA,
                        branch: process.env.REACT_APP_GIT_BRANCH,
                    }}>
                    <Router history={history}>
                        <AuthProvider>
                            <HelmetProvider>{children}</HelmetProvider>
                        </AuthProvider>
                    </Router>
                </DebugMenu>
            </DarkModeProvider>
        </RecoilRoot>
    );
};

export default Providers;
